import { ShiftOpportunityType } from '@amzn/atoz-shiftapp-types';
import { DateTime } from 'luxon';
export function getDropOpportunityByShiftId(scheduleShift, shiftOpportunities) {
    if (!shiftOpportunities.length) {
        return null;
    }
    for (var _i = 0, shiftOpportunities_1 = shiftOpportunities; _i < shiftOpportunities_1.length; _i++) {
        var shiftOpportunity = shiftOpportunities_1[_i];
        if (shiftOpportunity.type === ShiftOpportunityType.Drop &&
            shiftOpportunity.shift.id === scheduleShift.shift.id) {
            return shiftOpportunity;
        }
    }
    // none found
    return null;
}
export function getDropOpportunitiesByTimeRange(scheduleShift, shiftOpportunities) {
    if (!shiftOpportunities.length) {
        [];
    }
    var dropOpportunities = [];
    var scheduleShiftStartTime = DateTime.fromISO(scheduleShift.shift.timeRange.start);
    var scheduleShiftEndTime = DateTime.fromISO(scheduleShift.shift.timeRange.end);
    var currentTime = DateTime.local();
    for (var _i = 0, shiftOpportunities_2 = shiftOpportunities; _i < shiftOpportunities_2.length; _i++) {
        var shiftOpportunity = shiftOpportunities_2[_i];
        var opportunityStartTime = DateTime.fromISO(shiftOpportunity.shift.timeRange.start);
        var opportunityEndTime = DateTime.fromISO(shiftOpportunity.shift.timeRange.end);
        if (shiftOpportunity.type === ShiftOpportunityType.Drop &&
            currentTime <= opportunityStartTime &&
            scheduleShiftStartTime <= opportunityStartTime &&
            scheduleShiftEndTime >= opportunityEndTime) {
            dropOpportunities.push(shiftOpportunity);
        }
    }
    dropOpportunities.sort(function (a, b) {
        var startTimeA = DateTime.fromISO(a.shift.timeRange.start).toMillis();
        var startTimeB = DateTime.fromISO(b.shift.timeRange.start).toMillis();
        // sort ascending
        return startTimeA - startTimeB;
    });
    // none found
    return dropOpportunities;
}
